<footer class="main-footer">
  <div class="container footer-blocks">
    <div class="block-wrapper">
      <h4 class="title">{{ "footer.benefits.title" | translate }}</h4>
      <app-benefits-list [useFooterVersion]="true" />
    </div>

    <div class="block-wrapper">
      <h4 class="title">{{ "footer.customer_service.title" | translate }}</h4>
      <a href="/service/newsletter">{{ "footer.customer_service.link.newsletter" | translate }}</a>
      <a href="https://www.ophardt.com/de/nachhaltigkeit" target="_blank" rel="noopener noreferrer">
        {{ "footer.customer_service.link.sustainability" | translate }}
      </a>

      <a href="/service">{{ "footer.customer_service.link.help_FAQ" | translate }}</a>
    </div>

    <div class="reference-blocks">
      <div class="block-wrapper">
        <h4 class="title">{{ "footer.payment_methods.title" | translate }}</h4>
        <app-references-list [assetPaths]="paymentMethodLogoPaths" [useBackgroundWrapper]="true" />
      </div>
      <div class="block-wrapper">
        <h4 class="title">{{ "footer.shipping_providers.title" | translate }}</h4>
        <app-references-list [assetPaths]="shippingServiceLogoPaths" [useBackgroundWrapper]="true" />
      </div>
      <div class="block-wrapper">
        <h4 class="title">{{ "footer.awards.title" | translate }}</h4>
        <ul class="awards-list">
          <li class="award">
            <div class="award-seal">
              <img [ngSrc]="'footer.awards.brand.image' | translate" width="48" height="48" [alt]="'footer.awards.brand.alt' | translate" />
            </div>
            <div class="award-copy">
              <p class="award-name">{{ "footer.awards.brand.title" | translate }}</p>
              <p class="award-description">{{ "footer.awards.brand.description" | translate }}</p>
            </div>
          </li>
          <li class="award">
            <div class="award-seal">
              <img [ngSrc]="'footer.awards.research.image' | translate" width="48" height="48" [alt]="'footer.awards.research.alt' | translate" />
            </div>
            <div class="award-copy">
              <p class="award-name">{{ "footer.awards.research.title" | translate }}</p>
              <p class="award-description">{{ "footer.awards.research.description" | translate }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="block-wrapper">
      <h4 class="title">{{ "footer.support_service.title" | translate }}</h4>

      <div class="working-hours-info">
        <h5 class="subtitle">{{ "footer.support_service.working_hours.title" | translate }}</h5>
        <p class="working-hours-text">{{ "footer.support_service.working_hours.weekdays" | translate }}</p>
        <p class="working-hours-text">{{ "footer.support_service.working_hours.friday" | translate }}</p>
      </div>

      <div class="support-links-wrapper">
        <div class="support-option">
          <app-icon color="red" name="Phone" size="lg" />
          <a class="contact-support-link" href="tel:+4928351810">+49 2835 1810</a>
        </div>
        <div class="support-option">
          <app-icon color="red" name="Mail" size="lg" />
          <a class="contact-support-link" href="mailto:kontakt-shop@ophardt.com">kontakt-shop&#64;ophardt.com</a>
        </div>
        <app-zoho-livechat-button />
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="container">
      <div class="info-wrapper">
        <app-footer-info-links />
        <p class="rights-text">© {{ currentYear }} OPHARDT Hygiene. Alle Rechte vorbehalten.</p>
      </div>
    </div>
  </div>
</footer>
